var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerTypeB2C(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.0013 7.16667C6.16035 7.16667 4.66797 5.67428 4.66797 3.83333C4.66797 1.99238 6.16035 0.5 8.0013 0.5C9.84225 0.5 11.3346 1.99238 11.3346 3.83333C11.3346 5.67428 9.84225 7.16667 8.0013 7.16667Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500543 14.8314C0.823549 10.8541 4.05159 8.83203 7.98612 8.83203C11.976 8.83203 15.2541 10.743 15.4983 14.832C15.508 14.9949 15.4983 15.4987 14.8722 15.4987C11.7843 15.4987 7.1956 15.4987 1.10625 15.4987C0.89726 15.4987 0.482949 15.048 0.500543 14.8314Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTypeB2C);
export default __webpack_public_path__ + "static/media/customerTypeB2C.1f686cc820a7f164cc860adab19ad4ba.svg";
export { ForwardRef as ReactComponent };